import { useState } from 'react';
import Button from '../Button/Button';
import Input from '../Input/Input';
function PasswordInput(props) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="password-field">
      <Input
        {...props}
        endAdornment={(
          <Button aria-label={visible ? 'Hide password' : 'Show password'} className="password-field__toggle" onClick={() => setVisible((value) => !value)} variant="text">
            {visible ? 'Hide' : 'Show'}
          </Button>
        )}
        type={visible ? 'text' : 'password'}
      />
    </div>
  );
}
export default PasswordInput;
